<template>
  <div class="list-block media-list" style="width: 100%;"  v-if="tvInfo.length > 0">
    <div class="searchbar row">
      <div class="search-input col-80" style="margin-left: 1.5rem;width: 73%">
        <input  id='search' placeholder='载体' v-model="searchdata" />
      </div>
      <a class="button button-fill button-primary col-15" @click="filterTVOptions(TVInfoFilters)"><span class="icon icon-search"></span></a>
    </div>
    <!-- 筛选项 -->
    <div class="content-block-title title-label">筛选项</div>
    <div v-for="(filter, index) in filterOptionAttributes" class="filter-option">
      <van-dropdown-menu :index="index">
        <van-dropdown-item :title="filter.name" disabled title-class="blue-title"></van-dropdown-item>
        <van-dropdown-item v-model="TVInfoFilters[filter.data]" :options="filterOptions[filter.attribute]" />
      </van-dropdown-menu>
    </div>
    <div class="content-block-title title-label">{{this.attribute.label}}</div>
    <ul style="padding-left: 0rem;" v-if="serarchOptions.length > 0 || onlyShowSearchOptions">
      <li v-for="(opt,idx) in serarchOptions">
        <label v-if="showCustomMade(opt.WQFlag)" class="label-checkbox item-content">
          <input type="radio" name="my-radio" :value="opt.TLNo" v-model="attribute.value" >
          <div class="item-media"><i class="icon icon-form-checkbox"></i></div>
          <div class="item-inner" @click="changePeriod">
            <div class="item-title-row">
              <div class="item-title">
               <span style="margin-right: 0.8rem">
                {{opt.TLNo}}
               </span>
                <span style="margin-right: 0.8rem" v-if="opt.promoterAAV !== undefined">
                 {{opt.promoterAAV}}
              </span>
                <span v-if="opt.WQFlag === 1">
                  推荐
              </span>
                <span v-if="opt.WQFlag === 2">
                  可用
              </span>
                <span v-if="opt.WQFlag === 3">
                 不可用
              </span>
                <span v-if="opt.tag5ID === 1">
                 特异性启动子
              </span>
              </div>
            </div>
            <div class="item-text">
              {{opt.elementSeq}}
            </div>
            <span v-if="opt.RNAiEffect">包装容量：{{opt.RNAiEffect}}</span>
            <div v-if="opt.recommendSerotype">小鼠参考血清型：{{opt.recommendSerotype}}</div>
            <div v-if="opt.toolVectorApply">载体适用：{{opt.toolVectorApply}}</div>
          </div>
        </label>
      </li>
    </ul>
    <ul style="padding-left: 0rem;" v-else>
      <li v-for="(opt,idx) in tvInfo">
        <label v-if="showCustomMade(opt.WQFlag)" class="label-checkbox item-content">
          <input type="radio" name="my-radio" :value="opt.TLNo" v-model="attribute.value"  >
          <div class="item-media"><i class="icon icon-form-checkbox"></i></div>
          <div class="item-inner" @click="changePeriod">
            <div class="item-title-row">
              <div class="item-title">
                <span style="margin-right: 0.5rem">
                {{opt.TLNo}}
               </span>
                <span style="margin-right: 0.5rem" v-if="opt.promoterAAV !== undefined">
                 {{opt.promoterAAV}}
              </span>
                <span v-if="opt.WQFlag === 1">
                  推荐
              </span>
                <span v-if="opt.WQFlag === 2">
                 可用
              </span>
                <span v-if="opt.WQFlag === 3">
                 不可用
              </span>
                <span v-if="opt.tag5ID === 1">
                   &nbsp &nbsp 特异性启动子
              </span>
              </div>
            </div>
            <div class="item-text"> {{opt.elementSeq}}</div>
            <span  v-if="opt.RNAiEffect && opt.RNAiEffect !== '0'">包装容量：{{opt.RNAiEffect}}</span>
            <div v-if="opt.recommendSerotype">小鼠参考血清型：{{opt.recommendSerotype}}</div>
            <div v-if="opt.toolVectorApply">载体适用：{{opt.toolVectorApply}}</div>
          </div>
        </label>
      </li>
    </ul>
  </div>
  <div  v-else style="margin:0 auto">
    <div>没有可选择的载体编号，请选择下一步！</div>
  </div>
</template>

<script>
import $ from 'jquery'
import {mapMutations} from 'vuex'
import Emkt from '../../emkt'
export default {
  name: 'attr-tv-box',
  data () {
    return {
      tvOptions: [],
      searchdata: '',
      serarchOptions: [],
      // 当查询不到载体时，此变量为true，表示只显示空的筛选结果
      onlyShowSearchOptions: false,
      blood: Emkt.getLocalStorage('BloodOptionsChoose'),
      TVInfoFilters: {
        selectedWQFlag: -1,
        selectedTag1ID: -1,
        selectedEuRID: -1,
        selectedTag2ID: -1,
        selectedTag5ID: -1
      },
      filterOptionAttributes: [
        {attribute: 'WQFlag', name: '级别', data: 'selectedWQFlag'},
        {attribute: 'tag1ID', name: '荧光蛋白', data: 'selectedTag1ID'},
        {attribute: 'eu_RID', name: '真核抗性', data: 'selectedEuRID'},
        {attribute: 'tag2ID', name: '融合标签', data: 'selectedTag2ID'},
        {attribute: 'tag5ID', name: '启动子类型', data: 'selectedTag5ID'}
      ],
      // erp-typeID： WQFlag=1694  tag1ID，tag2ID=1647   eu_RID=1645  tag5ID=1985
      filterOptions: {
        'WQFlag': [{text: '请选择', value: -1}, {text: '推荐', value: 1}, {text: '常用', value: '2,4'}, {text: '不常用', value: 3}],
        'tag1ID': [{text: '请选择', value: -1}, {text: '无荧光', value: -999}, {text: 'GFP（绿色）', value: '0,5,7,24'}, {text: 'RFP（红色）', value: 1}, {text: 'dsRED（红色）', value: 6}, {text: 'cherry（红色）', value: 4}, {text: 'firefly_Luciferase（荧光素酶）', value: 8}, {text: 'Renilla _Luciferase（海肾荧光素酶）', value: 13}, {text: 'firefly_Luciferase+Renilla_Luciferase（双荧光素酶）', value: 23}, {text: '其他', value: 999}],
        'eu_RID': [{text: '请选择', value: -1}, {text: 'Puromycin(嘌呤)', value: 2}, {text: 'Neomycin(新霉素)', value: 0}, {text: 'Hygromycin(潮霉素)', value: 1}, {text: 'Blasticidin(杀稻瘟菌素)', value: 5}],
        'tag2ID': [{text: '请选择', value: -1}, {text: '独立表达', value: -999}, {text: '融合荧光', value: '1,6,7,20'}, {text: '融合标签', value: '14,15,16,21'}],
        'tag5ID': [{text: '请选择', value: -1}, {text: '广谱启动子', value: 0}, {text: '特异性启动子', value: 1}]
      }
    }
  },
  props: [
    'attribute', 'index', 'curAttrsInGroup', 'attrGroups'
  ],
  mounted () {
    this.tvOptionsHandler()
  },
  created () {
  },
  computed: {
    tvInfo () {
      var opt = []
      this.serarchOptions = []
      this.tvOptions.forEach(data => {
        let obj = {}
        for (var i in data) {
          obj[i] = data[i]
        }
        opt.push(obj)
      })
      // let group = this.curAttrsInGroup
      // for (var j in opt) {
      //   for (var i in group) {
      //     let colName = group[i].columnName
      //     let name = colName.substring(7, colName.length)
      //     let info = opt[j][name]
      //     if (info) {
      //       let val = group[i].options
      //       if (val) {
      //         opt[j][name] = val[info]
      //       }
      //     }
      //   }
      // }
//        if (opt && opt.length < 1) {
//          Emkt.setLocalStorage('TLNo', null)
//        }
      let data = Emkt.getLocalStorage('TLNo')
      if (data !== undefined && data !== null && opt.length > 0) {
        var newopt = []
//          for (var k in opt) {
//            if (opt[k].TLNo.indexOf(data) !== -1) {
//              newopt.push(opt[k])
//              Emkt.setLocalStorage('TLNo', null)
//            }
//          }
        var d = {}
        d.TLNo = data
        newopt.push(d)
//          Emkt.setLocalStorage('TLNo', null)
        return newopt
      } else {
        return opt
      }
    }
  },
  methods: {
    ...mapMutations([
      'UPDATE_CUST_REMARK', 'UPDATE_CUST_REMARK1'
    ]),
    control (val) {
      if (this.attrGroups && val.RNAiEffect && val.RNAiEffect !== '0') {
        if (this.attrGroups[0].attrs[10].value > parseInt(val.RNAiEffect)) {
          if (this.attrGroups[0].attrs[12].value === '1') {
            $.confirm('基因的CDS大小' + this.attrGroups[0].attrs[10].value + '超出载体包装容量，请咨询售前解决方案!')
          } else if (this.attrGroups[0].attrs[13].value === '2' || this.attrGroups[0].attrs[13].value === '3') {
            $.confirm('基因的CDS大小' + this.attrGroups[0].attrs[10].value + '超出合同承诺有效靶点大小范围，请确认风险!')
          } else if (this.attrGroups[0].attrs[12].value === '2' || (this.attrGroups[0].attrs[12].valueText !== undefined && this.attrGroups[0].attrs[13].valueText.indexOf('Cas9') !== -1)) {
            $.confirm('基因的CDS大小' + this.attrGroups[0].attrs[10].value + '超出承诺，请咨询售前解决方案!')
          }
//            alert('基因的CDS大小' + this.attrGroups[0].attrs[9].value + '超过载体的包装容量!请选择其他载体或重新选择基因!')
          Emkt.setLocalStorage('isnext', true)
        } else {
          Emkt.setLocalStorage('isnext', true)
        }
      }
      if (this.attrGroups && (this.attrGroups[0].attrs[6].value.category === 3 || this.attrGroups[0].attrs[6].value.category === 2) && (this.attrGroups[0].attrs[6].value.ttttflag !== undefined && this.attrGroups[0].attrs[6].value.ttttflag === 1) && (val.TTTTFlag !== undefined && val.TTTTFlag === 0)) {
        this.$weui.alert('您选择的miRNA存在4个连续的T，使用U6启动子构建有提前转录终止的可能，建议您返回上一步重新选择启动子为Ubi，CMV等二型启动子的载体')
        Emkt.setLocalStorage('isnext', false)
      }
      this.$emit('controlForm', this.index, this.curAttrsInGroup)
      console.log(this.attrGroups)
      if (this.attribute.value === 'GV127' || this.attribute.value === 'GV311' || this.attribute.value === 'CV032' || this.attribute.value === 'CV253' || this.attribute.value === 'CV033' || this.attribute.value === 'CV271' || this.attribute.value === 'CV604' || this.attribute.value === 'CV232' || this.attribute.value === 'CV627' || this.attribute.value === 'CV627' || this.attribute.value === 'CV252' || this.attribute.value === 'CV104') {
        this.attrGroups[2].attrs[23].isNA = false
        this.UPDATE_CUST_REMARK('请提供改造合同号')
        this.UPDATE_CUST_REMARK1('')
      } else {
        this.attrGroups[2].attrs[23].isNA = true
        this.UPDATE_CUST_REMARK('请填写具体靶点序列或靶点编号或合同号')
        this.UPDATE_CUST_REMARK1('请避开以下靶点:')
      }
      if ((this.attrGroups[0].attrs[13].value === '2') || (this.attrGroups[0].attrs[13].value === '7')) {
        if (this.attrGroups[0].attrs[0].value === '1' && this.attrGroups[0].attrs[10].value === '2' && this.attrGroups[0].attrs[11].value === '2') {
          this.attrGroups[2].attrs[22].isNA = true
        } else {
          this.attrGroups[2].attrs[22].isNA = false
        }
      }
      if (this.attrGroups[0].attrs[2].value === '4') {
        this.attrGroups[2].attrs[2].options = this.blood
        this.attrGroups[2].attrs[2].isNA = false
      }
    },
    searchTVByKeyword () {
      let data = this.searchdata
      const updateSerarchOptions = []
      for (var i = 0; i < this.serarchOptions.length; i++) {
        if ((this.serarchOptions[i].TLNo && this.serarchOptions[i].TLNo.indexOf(data.toUpperCase()) !== -1) || (this.serarchOptions[i].elementSeq && this.serarchOptions[i].elementSeq.toLowerCase().indexOf(data.toLowerCase()) !== -1) ||
            (this.serarchOptions[i].promoterAAV && this.serarchOptions[i].promoterAAV.indexOf(data) !== -1)) {
          updateSerarchOptions.push(this.serarchOptions[i])
        }
      }
      this.serarchOptions = updateSerarchOptions
    },
    tvOptionsHandler () {
      // debugger
      let param = this.attribute.options
      console.log(this.attrGroups)
      let _this = this
      $.showIndicator()
      this.gcapi('getToolVectorsByTLNos', param).then(res => {
        let body = res.body
        _this.tvOptions = body.result
        _this.tvOptions.sort(function (a, b) {
          return a.WQFlag - b.WQFlag
        })
        _this.tvOptions = _this.tvOptions.filter(tv => {
          let gene = _this.attrGroups[0].attrs[6].value
          let canUse = true
          if (gene) {
            let geneCategory = gene.geneCategory
            if (geneCategory) {
              let recommendGeneTypeUse = true
              let availableGeneType = true
              if(tv.recommendGeneType !== undefined) {
                if(!tv.recommendGeneType.includes(geneCategory)) {
                  recommendGeneTypeUse = false
                }
              } else {
                recommendGeneTypeUse = undefined
              }
              if(tv.availableGeneType !== undefined) {
                if(!tv.availableGeneType.includes(geneCategory)) {
                  availableGeneType = false
                }
              } else {
                availableGeneType = undefined
              }
              if((recommendGeneTypeUse === false && availableGeneType === false) || (recommendGeneTypeUse === undefined && availableGeneType === false) || (availableGeneType === undefined && recommendGeneTypeUse === false)) {
                canUse = false
              }
            }
          }
          if(canUse) {
            let expresstionTest = tv.expresstionTest
            if (expresstionTest !== '' && expresstionTest !==undefined && _this.attrGroups[0].attrs[19].value.toString() !== '-1') {
              if (!expresstionTest.includes(_this.attrGroups[0].attrs[19].value)) {
                canUse = false
              }
            }
            if(_this.attrGroups[0].attrs[19].value.toString() !== '-1' && (expresstionTest === '' || expresstionTest === undefined)) {
              canUse = false
            }
          }
          if(canUse) {
            let inducingTest = tv.inducingTest
            if (inducingTest !== '' && inducingTest !==undefined && _this.attrGroups[0].attrs[20].value.toString() !== '-1') {
              if (!inducingTest.includes(_this.attrGroups[0].attrs[20].value)) {
                canUse = false
              }
            }
            if(_this.attrGroups[0].attrs[20].value.toString() !== '-1' && (inducingTest === '' || inducingTest === undefined)) {
              canUse = false
            }
          }
          return canUse
        })
        setTimeout(function () {
          $.hideIndicator()
        }, 300)
      })
    },
    changePeriod () {
      if (this.attribute.value === '' && $("input[type='radio']:checked").val() !== undefined && $("input[type='radio']:checked").val() !== '') {
        this.attribute.value = $("input[type='radio']:checked").val()
        this.GoNext($("input[type='radio']:checked").val())
      }
    },
    GoNext (val) {
      Emkt.setLocalStorage('isnext', true)
      this.attribute.valueText = val
      let group = this.curAttrsInGroup
      let tvInfo = this.tvOptions
      let checkedTvInfo = {}
      for (var j in tvInfo) {
        if (tvInfo[j].TLNo === val) {
          checkedTvInfo = tvInfo[j]
        }
      }
      for (var i in group) {
        let colName = group[i].columnName
        let info = checkedTvInfo[colName.substring(7, colName.length)]
        if (info !== undefined) {
          group[i].value = info
          let opt = group[i].options
          if (opt) {
            group[i].valueText = opt[info]
          } else {
            group[i].valueText = info
          }
        } else if (colName !== 'TVInfo') {
          group[i].value = -1
          group[i].valueText = 'NA'
        }
      }
//        Emkt.setLocalStorage('TLNo', null)
      this.control(checkedTvInfo)
//        if (!this.$route.query.cust) {
//          this.$emit('controlForm', this.index, this.curAttrsInGroup, this.attribute)
//        }
    },
    /* eslint-disable */
    filterTVOptions (val) {
      console.log('watch TVInfoFilters', val, this.tvInfo)
      const validFilters = {}
      for (let key in val) {
        if (val[key] !== -1) {
          let targetOptionAttribute = this.filterOptionAttributes.find(option => option.data === key)
          let targetAttribute = targetOptionAttribute && targetOptionAttribute.attribute
          validFilters[targetAttribute] = val[key]
        }
      }
      console.log('validFilters', validFilters)
      this.serarchOptions = this.tvInfo.filter(tv => {
        for (let attr in validFilters) {
          let selectedValue = validFilters[attr]
          let tvAttrValue = tv[attr]
          // 判断属性值是否为空  为空：value !== 0 && value === null/undefined
          if (selectedValue === -999) {
            if (tvAttrValue === 0 || !!tvAttrValue) {
              return false
            }
          }
          // 判断"其他"类型，即非选项中包含的其他枚举值
          else if (selectedValue === 999) {
            let inValidOptions = this.filterOptions[attr].filter(option => ![999,-999,-1].includes(option.value)).map(op => op.value)
            console.log('inValidOptions', inValidOptions)
            if (inValidOptions.includes(tvAttrValue)) {
              return false
            }
          }
          else {
            let selectedValues = String(validFilters[attr]).split(",")
            if (!selectedValues.includes(String(tvAttrValue))) {
              return false
            }
          }
        }
        return true
      })
      // 根据输入的关键字搜索载体信息
      if (this.searchdata !== '') {
        this.searchTVByKeyword()
      }
      if (this.serarchOptions.length === 0) {
        this.onlyShowSearchOptions = true
        alert('查询结果无此载体！')
      }
      console.log('filterTVOptions serarchOptions：', this.serarchOptions)
    },
    showCustomMade(WQFlag ){
      console.log('WQFlag:', WQFlag)
      console.log('attrs:', this.attrGroups[0].attrs[0])
      console.log('value:', this.attrGroups[0].attrs[0].value)
      console.log('showCustomMade:', WQFlag === 3 && this.attrGroups && (this.attrGroups[0].attrs[0].value !== '1' || this.attrGroups[0].attrs[0].value !== '4'))
      return !(WQFlag === 3 && this.attrGroups && (this.attrGroups[0].attrs[0].value === '1' || this.attrGroups[0].attrs[0].value === '4'))
    }
  },
  watch: {
    'attribute.value': function (val) {
      this.GoNext(val)
    },
    'TVInfoFilters': {
      handler: 'filterTVOptions',
      deep: true
    }
  }
}
</script>
<style>
.filter-option .blue-title {
  color: #0894ec!important;
}
.filter-option .blue-title:after {
  opacity: 0!important;
}
.filter-option .van-dropdown-menu__item {
  justify-content: flex-start;
}
.filter-option .van-dropdown-menu__item--disabled {
  flex: 0.5;
}
</style>
<style scoped>
input {
  border: 1px solid #ccc;
  outline: 0;
  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
}
.error input {
  border-color: rgba(246, 58, 56, .8);
  box-shadow: 0 0 8px rgba(246, 58, 56, .6);
}
select:required:invalid {
  color: gray;
}
.title-label{
  margin-top: 0.75rem;
  border-bottom: 1px solid #E5E5E5;
  margin-bottom: 0.75rem;
  height: 1.2rem;
  font-weight: 900;
  font-size: 0.75rem;
}
</style>


// WEBPACK FOOTER //
// AttrTVBox.vue?72a49df1